import { useState, useEffect } from 'react';
import Card from '../../components/Card';
import Header from '../../components/Header';
import FlashMessage from '../../components/FlashMessage';
import Stack from '../../components/Stack';
import CompetitionCard from '../../components/admin/CompetitionCard';
import { useAdminCompetitions } from '../../hooks/admin/useAdminCompetitions';
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'

export default function AdminCompetitions() {
  const competitions = useAdminCompetitions();
  const [localComps, setLocalComps] = useState([]);
  const navigate = useNavigate()

  useEffect(() => {
    setLocalComps(competitions);
  }, [competitions]);

  const handleCreateNew = () => {
    navigate(`/admin/competitions/editing/${false}/null`)
  }

  return (
    <Card className='gap-6'>
      <Stack width="full" align="start" direction="col" className='gap-6'>
        <Stack width="full" direction='row' justify='between' className="gap-4">
          <Stack width="full" align="start" direction="col" className="gap-1">
            <Header size="xl">Competitions</Header>
            <p className="text-sm">View and manage all competitions</p>
          </Stack>
          <Button
            onClickMethod={handleCreateNew}
            className='max-w-max p-2'
          >
            Create New
          </Button>
        </Stack>
        <FlashMessage />

        <div className="w-full">
          {localComps.length > 0 && localComps.map((competition) => (
            <CompetitionCard
              key={competition.id}
              competition={competition}
            />
          ))}
        </div>
      </Stack>
    </Card>
  );
}
